export default function unionArray(x, y) {
	return [...new Set([...x, ...y])];
}



// WEBPACK FOOTER //
// ./src/core/utils/unionArray.js